import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn || dsn.includes('...')) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    sendDefaultPii: false,
    tracesSampleRate: 0.1,
  });
}

export async function submitSentryFeedback({
  type,
  subject,
  message,
  email,
  currency,
  attachment,
}: {
  type: 'support' | 'idea';
  subject: string;
  message: string;
  email?: string;
  currency?: string;
  attachment?: File | null;
}) {
  const attachmentData = attachment ? new Uint8Array(await attachment.arrayBuffer()) : null;

  return Sentry.withScope((scope) => {
    if (attachment && attachmentData) {
      scope.addAttachment({
        filename: attachment.name,
        data: attachmentData,
        contentType: attachment.type || 'application/octet-stream',
      });
    }

    return Sentry.captureFeedback({
      message: `${subject}\n\n${message}`,
      email,
      tags: {
        feedback_type: type,
        feedback_source: 'clevia_custom_form',
        currency,
      },
    });
  });
}
